var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8454 7.15385V5.03846C8.8454 4.36522 9.11285 3.71955 9.5889 3.2435C10.065 2.76744 10.7106 2.5 11.3839 2.5C12.0571 2.5 12.7028 2.76744 13.1788 3.2435C13.6549 3.71955 13.9223 4.36522 13.9223 5.03846V7.15385M3.3454 13.5H9.26848C9.6051 13.5 9.92793 13.3663 10.166 13.1283C10.404 12.8902 10.5377 12.5674 10.5377 12.2308V8.42308C10.5377 8.08646 10.404 7.76362 10.166 7.5256C9.92793 7.28757 9.6051 7.15385 9.26848 7.15385H3.3454C3.00878 7.15385 2.68595 7.28757 2.44792 7.5256C2.20989 7.76362 2.07617 8.08646 2.07617 8.42308V12.2308C2.07617 12.5674 2.20989 12.8902 2.44792 13.1283C2.68595 13.3663 3.00878 13.5 3.3454 13.5Z",
    stroke: "currentColor",
    strokeWidth: 1.01538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lockOpen.49abf689a7e18302ed42cbf6f46c43eb.svg";
export { ForwardRef as ReactComponent };